<template>
  <el-cascader
    :size="size"
    :disabled="disabled"
    v-model="currentValue"
    :options="cascaderAreas"
    :props="{value: 'id',label: 'name'}"
    :placeholder="placeholder"
    @change="handleAreaChange"
    @focus="(_) => $emit('focus', _)"
    filterable
    :clearable="clearable"
    change-on-select
  ></el-cascader>
</template>

<script>

export default {
  components: {},
  props: {
    value: {
      type: Array,
      default: [],
    },
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    placeholder: {
      type: String,
      default: '请选择',
    },
  },
  data () {
    return {
      currentValue: this.value,
      initialize: null,
      cascaderAreas: [],
    }
  },
  computed: {
  },
  watch: {
    value () {
      if (!_.isEqual(this.value, this.currentValue)) {
        this.currentValue = this.value
        // 加载value中的市区
        this.initialize.then(this.loadCityAndDistrict)
      }
      if (this.disabled) {
        this.loadCityAndDistrict()
      }
    },
    currentValue () {
      if (!_.isEqual(this.value, this.currentValue)) {
        this.$emit('input', this.currentValue)
      }
    },
  },
  created () {
    // 初始化数据
    this.initialize = new Promise((resolve, reject) => {
      if (!this.cascaderAreas.length) {
        request('getProvinces').then(({data}) => {
          this.setProvinces(data)
          resolve()
        }, reject)
      } else {
        resolve()
      }
    })
    // 加载value中的市区
    this.initialize.then(this.loadCityAndDistrict)
  },
  mounted () {},
  methods: {
    loadCityAndDistrict () {
      let value = this.currentValue
      if (value.length >= 1) {
        this.handleAreaChange(value.slice(0, 1)).then(() => {
          if (value.length > 2) {
            this.handleAreaChange(value.slice(0, 2))
          }
        })
      }
    },
    setProvinces (data) {
      this.cascaderAreas = data.map(({id, name}) => {
        return {
          name,
          id,
          children: [],
        }
      })
    },
    setCities (provinceIndex) {
      let cascaderAreas = this.cascaderAreas
      let province = cascaderAreas[provinceIndex]
      return request.alert('getCities', {pid: province.id}).then(({data}) => {
        // 设置城市列表
        cascaderAreas[provinceIndex].children = data.map(({id, name}) => {
          return {
            name,
            id,
            children: [],
          }
        })
      })
    },
    setDistricts (provinceIndex, cityIndex) {
      let cascaderAreas = this.cascaderAreas
      let city = cascaderAreas[provinceIndex].children[cityIndex]
      return request.alert('getDistricts', {pid: city.id}).then(({data}) => {
        // 设置县区列表
        cascaderAreas[provinceIndex].children[cityIndex].children = data.map(({id, name}) => {
          return {name, id}
        })
      })
    },
    findProvince (id) {
      return _.findIndex(this.cascaderAreas, {id})
    },
    findCity (provinceIndex, id) {
      return _.findIndex(this.cascaderAreas[provinceIndex].children, {id})
    },
    handleAreaChange (selected) {
      let promise = null
      let provinceIndex = this.findProvince(selected[0])
      let province = this.cascaderAreas[provinceIndex]
      switch (selected.length) {
        case 1:
          // 不存在该省份的城市列表则请求获取
          if (!province.children.length) {
            promise = this.setCities(provinceIndex)
          }
          break
        case 2:
          let cityIndex = this.findCity(provinceIndex, selected[1])
          let city = province.children[cityIndex]
          // 不存在该城市的县区列表则请求获取
          if (!city.children.length) {
            promise = this.setDistricts(provinceIndex, cityIndex)
          }
          break
      }
      this.$emit('change', this.currentValue)
      return promise
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/area/components/CascaderDistrict.vue